import { getDataCookie } from 'common';
import MyDatePicker from 'components/DatePicker';
import Loader from 'components/Loader';
import { debounce } from 'lodash';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import aptActions from 'store/appt/actions';
import { aptUIActions } from 'store/appt/reducers';
import aptSelectors from 'store/appt/selectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import CalendarUI from './CalendarUI';
import addIcon from './CalendarUI/icons/add.svg';
import refreshIcon from './CalendarUI/icons/change.svg';
import SockJS from 'sockjs-client';
import constant from 'constant';
import { Client, Message, over } from 'stompjs';
import { CalendarDataItem } from 'types/models';

const FORMAT_DATE = 'MM-DD-YYYY';

const StaffCalendar = () => {
  const dispatch = useAppDispatch();
  const _history = useHistory();
  // REACT_APP_COOKIE_KEY is always defined at build time (mirrors common.ts's own usage of `!` on env keys).
  const staffId = getDataCookie(process.env.REACT_APP_COOKIE_KEY!);

  const loading = useAppSelector(aptSelectors.loading);
  const appointmentList = useAppSelector(aptSelectors.appointments);
  const blockHours = useAppSelector(aptSelectors.blockHours);
  const dateStr = useAppSelector(aptSelectors.date);
  const date = useMemo(() => moment(dateStr), [dateStr]);
  const setDate = (value: moment.Moment) => dispatch(aptUIActions.setDate(value));
	const staff_info = JSON.parse(localStorage.getItem('infor_staff')!);


  const fetchDataApt = async (range_param: string) => {
    let query = range_param;
    if (staffId) {
      query += '&staffId=' + staffId;
    }
    dispatch(aptActions.getAptData.fetch(query));
  };

  React.useEffect(() => {
    const dateMoment = date.format('YYYY-MM-DD');
    const range_param = `start_time=${dateMoment}&end_time=${dateMoment}`;
    fetchDataApt(range_param);
  }, []);

  // staffId (cookie) can genuinely be missing; CalendarUI's headers prop only
  // types string|number — cast preserves pre-existing behavior if cookie is unset.
  const calendarHeaders = useMemo(() => [staffId] as (string | number)[], [staffId]);
  const calendarDataSources = useMemo((): CalendarDataItem[] => (appointmentList as CalendarDataItem[]).concat(blockHours), [appointmentList, blockHours]);

  const viewAptDetail = ({ id, disabled }: { id: string; disabled?: boolean }) => {
    _history.push('/appointment-staff/' + id, { disabled });
  };
  const makeAppointment = () => {
    _history.push('/booking');
  }

  const onRefresh = () => {
    const dateMoment = date.format('YYYY-MM-DD');
    const range_param = `start_time=${dateMoment}&end_time=${dateMoment}`;
    fetchDataApt(range_param);
  }

    useEffect(() => {
      //setup socket
      var socket = new SockJS(constant.SOCKET_URL);
      let stompClient: Client;
      stompClient = over(socket);

      stompClient.connect({}, () => {
        stompClient.subscribe(`/topic/appointment-staff/${staffId}`, (res: Message) => {
          const dateMoment = date.format('YYYY-MM-DD');
          const range_param = `start_time=${dateMoment}&end_time=${dateMoment}`;
          fetchDataApt(range_param);
        });
      });
    }, []);

  return (
    <>
      {loading && <Loader />}
      <div className='staff-appointment-calendar-date-picker'>
        <div className="d-flex align-items-center" style={{ gap: '8px', paddingRight: '8px' }}>
          <MyDatePicker
            daily
            stringData={fetchDataApt}
            unsetMaxDate
            startFieldName='start_time'
            endFieldName='end_time'
            format='YYYY-MM-DD'
            style={{ flex: 1 }}
            onChange={setDate}
            value={date}
            customRender={({ icon, date }) => {
              return (
                <div className='date_picker_appointment' >
                  <div className="date_picker_appointment-label">{date?.format("ddd")} {date?.format(FORMAT_DATE)}</div>
                  <div className="date_picker_appointment-icon">
                    {icon}
                  </div>
                </div>)
            }}
          />
        </div>
      </div>
      <CalendarUI
        dateFilter={date}
        staffView
        headers={calendarHeaders}
        dataSource={calendarDataSources}
        viewAptDetail={viewAptDetail}
      />
      <StaffFAB onNewApt={makeAppointment} onRefresh={onRefresh} />
    </>
  )
}

export default StaffCalendar;

interface StaffFABProps {
  onBack?: () => void; // never wired up at this call site (no 'back' button rendered below)
  onNewApt: () => void;
  onRefresh: () => void;
}

const StaffFAB = ({ onBack, onNewApt, onRefresh }: StaffFABProps) => {
  const [show, setShow] = useState(false);
  const toggle = () => setShow(!show);
  const handleClick = (type: string) => () => {
    setShow(false);
    switch (type) {
      case 'refresh': return onRefresh();
      case 'new': return onNewApt();
      case 'back': return onBack!(); // onBack is never passed at this call site (no 'back' button rendered) — dead path, pre-existing risk if ever wired up
      default:
        break;
    }
  }
  return <div className='owner-calendar-kit calendar-staff-FAB'>
    <Button color={!show ? 'primary' : undefined} className={`fab-hamburger ${show ? 'show' : ''}`} onClick={toggle}>
      <div className="wrapper">
        {/* `class` -> `className`: same rendered "class" DOM attribute, required for TSX */}
        <span className="icon-bar" id="one"></span>
        <span className="icon-bar" id="two"></span>
        <span className="icon-bar" id="thr"></span>
      </div>
    </Button>
    <Button onClick={handleClick('refresh')} className={`fab-nav refresh-page ${show ? 'show' : ''}`}>
      <img src={refreshIcon} alt="refreshIcon" className='icon' />
    </Button>
    <Button color='primary' onClick={handleClick('new')} className={`fab-nav add-new ${show ? 'show' : ''}`}>
      <img src={addIcon} alt="addIcon" className='icon' />
    </Button>
    <div className={`fab-overlay ${show ? 'show' : ''}`}></div>
  </div>
}
